import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-access-management",
  templateUrl: "./access-management.component.html",
})
export class AccessManagementComponent implements OnInit {
  constructor(private appservice: AppService) {}
  errormsg = "";
  successmsg = "";
  accessManageMent = [];
  accessManageMents = [];
  accessManageMentGroup = [];
  cancelcode: any;
  newcancelcode: any;
  confirmcancelcode: any;
  accessManageMentOperation = [];
  accessManageMentOperations = [];
  accessManageMentAdmin = [];
  accessManageMentAdmins = [];
  accessManageMentOther = [];
  accessManageMentOthers = [];

  blockcode: any;
  newblockcode: any;
  confirmblockcode: any;
  accessManageMentList = [];
  accessManagementRows = [];

  permissionRowDefinitions = [
    { type: "permission", label: "Schedule Appointments", showTypeId: 0, bold: true },
    { type: "permission", label: "Message center", showTypeId: 21, bold: true },
    { type: "header", label: "Technologist Management" },
    { type: "permission", label: "Technologist Schedule", showTypeId: 1 },
    { type: "permission", label: "Technologist Vacation", showTypeId: 2 },
    { type: "permission", label: "Patient Information", showTypeId: 3, bold: true },
    { type: "permission", label: "Physician Information", showTypeId: 4, bold: true },
    { type: "header", label: "Admin" },
    { type: "subheader", label: "Image center profile" },
    { type: "permission", label: "Basic Information", showTypeId: 5 },
    { type: "permission", label: "Equipments", showTypeId: 6 },
    { type: "permission", label: "Procedures", showTypeId: 7 },
    { type: "permission", label: "Insurance", showTypeId: 8 },
    { type: "permission", label: "Technologist", showTypeId: 9 },
    { type: "permission", label: "Front Desk", showTypeId: 10 },
    { type: "permission", label: "Medical Questions", showTypeId: 11 },
    { type: "permission", label: "Access Management", showTypeId: 12 },
    { type: "header", label: "SchedMed Plan" },
    { type: "permission", label: "Credit Card", showTypeId: 13 },
    { type: "permission", label: "Billing", showTypeId: 14 },
    { type: "permission", label: "Analysis", showTypeId: 15, bold: true },
    { type: "permission", label: "Reviews", showTypeId: 16, bold: true },
    { type: "permission", label: "Reports", showTypeId: 17, bold: true },
    { type: "permission", label: "Buy and Bid Equipments", showTypeId: 18, bold: true },
    { type: "permission", label: "Service and Maintenance", showTypeId: 19, bold: true },
    { type: "permission", label: "Hiring Technicians", showTypeId: 20, bold: true },
  ];

  updateList: any = [];

  ngOnInit() {
    this.getAccess();
  }
  getAccess() {
    this.appservice.getAccess().subscribe(
      (res) => {
        this.updateList = [];
        this.accessManageMentList = [];
        this.accessManageMent = [];
        this.accessManageMents = [];
        this.accessManagementRows = [];
        if (res && res["entity"]) {
          this.accessManageMent = res["entity"];
          for (let index = 0; index < this.accessManageMent.length; index++) {
            const groupBy = this.accessManageMent[index].frontDeskId;
            this.accessManageMents[index] = this.accessManageMent[index];
            this.accessManageMents[index].groupBy = groupBy;
          }
          this.accessManageMentList = this.groupBy(
            this.accessManageMents,
            "groupBy"
          );
          this.buildAccessManagementRows();
        } else {
          this.accessManageMent = [];
          this.accessManageMents = [];
          this.accessManagementRows = [];
        }
      },
      () => {
        this.accessManageMent = [];
        this.accessManageMents = [];
        this.accessManagementRows = [];
      }
    );
  }
  onChangePermission(value) {
    this.updateList.push(value);
  }

  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key].sort((a, b) => {
        const first = this.getShowTypeId(a);
        const second = this.getShowTypeId(b);
        return first - second;
      }),
    }));
  }

  buildAccessManagementRows() {
    this.accessManagementRows = this.permissionRowDefinitions.map((row: any) => {
      if (row.type !== "permission") {
        return row;
      }

      return Object.assign({}, row, {
        permissions: this.accessManageMentList.map((group) =>
          this.findPermissionByShowTypeId(group, row.showTypeId)
        ),
      });
    });
  }

  findPermissionByShowTypeId(group, showTypeId) {
    if (!group || !group.value) {
      return null;
    }

    return group.value.find(
      (permission) => this.getShowTypeId(permission) === Number(showTypeId)
    );
  }

  getShowTypeId(permission) {
    if (!permission) {
      return Number.MAX_SAFE_INTEGER;
    }

    if (permission.showTypeId != null) {
      return Number(permission.showTypeId);
    }

    if (
      permission.accessManagement &&
      permission.accessManagement.showTypeId != null
    ) {
      return Number(permission.accessManagement.showTypeId);
    }

    return Number.MAX_SAFE_INTEGER;
  }

  saveAccessManagement() {
    let cancelcode = null;
    let cancelnewcode = null;

    let blockcode = null;
    let newblockcode = null;

    if (this.cancelcode && this.newcancelcode && this.confirmcancelcode) {
      if (this.newcancelcode !== this.confirmcancelcode) {
        this.clearmsg();
        this.errormsg = "Mismatch cancel confirm code";
        this.timeout();
        return;
      } else if (
        this.newcancelcode.toString().length < 3 &&
        this.confirmcancelcode.toString().length < 3
      ) {
        this.clearmsg();
        this.errormsg = "Code should be 4 digit";
        this.timeout();
        return;
      } else if (this.newcancelcode === this.confirmcancelcode) {
        cancelnewcode = this.newcancelcode;
        cancelcode = this.cancelcode;
      }
    }

    if (this.blockcode && this.newblockcode && this.confirmblockcode) {
      if (this.newblockcode !== this.confirmblockcode) {
        this.clearmsg();
        this.errormsg = "Mismatch block confirm code";
        this.timeout();
        return;
      } else if (
        this.newblockcode.toString().length < 3 &&
        this.confirmblockcode.toString().length < 3
      ) {
        this.clearmsg();
        this.errormsg = "Code should be 4 digit";
        this.timeout();
        return;
      } else if (this.newblockcode === this.confirmblockcode) {
        blockcode = this.blockcode;
        newblockcode = this.newblockcode;
      }
    }

    const data = {
      accessInputs:
        this.updateList && this.updateList.length > 0 ? this.updateList : null,
      blockCode: blockcode,
      newBlockCode: newblockcode,
      cancelCode: cancelcode,
      newCancelCode: cancelnewcode,
    };

    this.appservice.updateaccessmanagement(data).subscribe((res) => {
      if (
        res &&
        res["status"] &&
        res["status"]["status"] &&
        res["status"]["status"] === 200
      ) {
        this.cancelcode = "";
        this.newcancelcode = "";
        this.confirmcancelcode = "";
        this.blockcode = "";
        this.newblockcode = "";
        this.confirmblockcode = "";
        this.clearmsg();
        this.successmsg = "Success";
        this.timeout();
      } else if (
        res &&
        res["status"] &&
        res["status"]["status"] &&
        res["status"]["status"] === 229
      ) {
        this.clearmsg();
        this.errormsg = res["status"]["msg"];
        this.timeout();
      }
    });
  }

  clearmsg() {
    this.errormsg = "";
    this.successmsg = "";
  }

  timeout() {
    setTimeout(() => {
      this.errormsg = "";
      this.successmsg = "";
    }, 5000);
  }

  resetsaveAccessManagement() {
    this.clearmsg();
    this.getAccess();
    this.cancelcode = "";
    this.newcancelcode = "";
    this.confirmcancelcode = "";
    this.blockcode = "";
    this.newblockcode = "";
    this.confirmblockcode = "";
    this.updateList = [];
  }
}
